import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Login from "./components/Pages/Auth/Login";
import Signup from "./components/Pages/Auth/Signup";
import Blog from "./components/Pages/Blog/Blog";
import CreateBlog from "./components/Pages/Create/CreateBlog";
import Home from "./components/Pages/Home/Home";
import About from "./components/Pages/About/About.js";
import "./styles/App.css";
import AuthContext from "./store/auth-context";

function App() {
  const authCtx = React.useContext(AuthContext);
  const auth = authCtx.isAuthenticated;
  return (
    <Layout>
      <Routes>
        <Route path="/" exact element={<Home />} />
        {auth && <Route path="/createblog" element={<CreateBlog />} />}
        {auth && <Route path="/blog" element={<Blog />} />}
        {auth && <Route path="/about" element={<About />} />}
        {!auth && <Route path="/login" element={<Login />} />}
        {!auth && <Route path="/signup" element={<Signup />} />}
        {!auth && <Route path="*" element={<Navigate to="/login" />} />}
        {auth && <Route path="*" element={<Navigate to="/blog" />} />}
      </Routes>
    </Layout>
  );
}

export default App;
